import {
  DebouncedTextInput,
  Group,
  GroupItem,
  Toolbar,
  TransactionLogsField,
  TransactionNotesInput,
  TransactionNotesIsPrivateInput,
  useSaveMutation,
} from "ra-friendsofbabba";
import {
  FormTab,
  NumberInput,
  TabbedForm,
  email,
  required,
  useNotify,
  usePermissions,
  useRedirect,
  useRefresh,
} from "react-admin";
import {
  Input,
  ProjectProposalInput,
  TextContentInput,
  UserResearcherInput,
} from "../component/input";
import React, { useMemo } from "react";

import CollaborationsField from "./fields/CollaborationsField";
import DocsField from "./fields/DocsField";
import EquipmentsField from "./fields/EquipmentsField";
import ExpertInput from "./inputs/ExpertInput";
import PrintButton from "../component/button/PrintButton";
import TimeScheduleField from "./fields/TimeScheduleField";
import UsersField from "./fields/UsersField";
import WorkPackagesField from "./fields/WorkPackagesField";
import { get } from "lodash";

const Form = ({ ...props }) => {
  const { loaded, permissions } = usePermissions();
  const isAdmin = useMemo(
    () => loaded && permissions(["admin"]),
    [loaded, permissions]
  );
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();
  const save = useSaveMutation({
    ...props,
    onSuccess: (response, values) => {
      const prevState = get(values, "transaction.state");
      const nextState = get(response, "data.state");
      const isMoved = prevState !== nextState;
      notify(
        `resources.executive-projects.messages.${values.state}_${
          isMoved ? "moved" : "loop"
        }.save_success`
      );
      if (values.id > 0) {
        refresh();
      } else {
        redirect("edit", props.basePath, response.data.id);
      }
    },
  });
  return (
    <TabbedForm
      {...props}
      save={save}
      warnWhenUnsavedChanges
      initialValues={{
        is_private: false,
      }}
      toolbar={
        <Toolbar useWorkflow maxButtonsToDisplay={1}>
          <PrintButton />
        </Toolbar>
      }
    >
      <FormTab label={"resources.executive-projects.tabs.the_project"}>
        <Input
          source="project_proposal_id"
          project_proposal="project_proposal"
          validate={required()}
          fullWidth
          component={<ProjectProposalInput />}
        />
        <Input source="user_id" fullWidth component={<UserResearcherInput />} />
        <Group fullWidth>
          <GroupItem lg={6} md={6} sm={12}>
            <Input source="expert_id" component={<ExpertInput />} />
          </GroupItem>

          <GroupItem lg={6} md={6} sm={12}>
            <Input
              source="delay"
              helperText="resources.executive-projects.fields.delay.help"
              component={<NumberInput />}
            />
          </GroupItem>
        </Group>
        <UsersField source="users" fullWidth />
        <Input
          source="referent_name"
          validate={!isAdmin ? required() : null}
          maxLength={50}
          fullWidth
          component={<DebouncedTextInput />}
        />
        <Group fullWidth>
          <GroupItem lg={6} md={12} sm={12}>
            <Input
              source="referent_email"
              validate={!isAdmin ? [required(), email()] : []}
              maxLength={250}
              component={<DebouncedTextInput />}
            />
          </GroupItem>
        </Group>
        <Input
          source="results"
          maxLength={1500}
          multiline
          fullWidth
          validate={[required()]}
          component={<TextContentInput />}
        />
        <TransactionLogsField admin={isAdmin} source="logs" fullWidth />

        {isAdmin && (
          <TransactionNotesInput
            source="notes"
            helperText="resources.transactions.fields.notes.help"
            fullWidth
          />
        )}
        {isAdmin && (
          <TransactionNotesIsPrivateInput
            admin={isAdmin}
            source="is_private"
            helperText="resources.transactions.fields.is_private.help"
            fullWidth
          />
        )}
      </FormTab>

      <FormTab label={"resources.executive-projects.tabs.details"}>
        <Input
          source="work_packages"
          fullWidth
          component={<WorkPackagesField />}
        />
        <Input
          source="collaborations"
          fullWidth
          component={<CollaborationsField />}
        />
        <Input source="equipments" fullWidth component={<EquipmentsField />} />
      </FormTab>
      <FormTab label={"resources.executive-projects.tabs.time_schedule"}>
        <TimeScheduleField source="work_packages" fullWidth />
      </FormTab>
      <FormTab label={"resources.executive-projects.tabs.docs"}>
        <Input source="docs" fullWidth component={<DocsField />} />
      </FormTab>
    </TabbedForm>
  );
};
export default Form;
